"use client";
import Button from "@/components/Button/Button.component";
import { BUTTON_SUBTYPE_CLASS } from "@/components/Button/Button.model";
import Image from "@/components/Image/Image.component";
import { Typography } from "@/components/Typography/Typography.component";
import { OfficeDetailsPropsModel } from "./OfficeDetails.model";
import "./OfficeDetails.style.css";

const OfficeDetails = ({
  city,
  address,
  contactNumber,
  mapAsset,
  directionsLink,
  handleClickGetInTouch,
  handleClickClose,
}: OfficeDetailsPropsModel) => (
  <div className="office__details bg-core-black text-core-white max-h-[90vh] w-[438px] overflow-y-auto max-md:w-screen">
    <div className="p-md max-md:px-sm max-md:w-screen">
      <div className="gap-y-sm grid">
        <div className="flex items-center justify-between">
          <Typography.H7>{city}</Typography.H7>
          <Button
            primary={true}
            type={BUTTON_SUBTYPE_CLASS.PRIMARY_WHITE}
            content={{
              text: "\u{2715}",
            }}
            className="btn--close rounded-full px-[9px] py-0"
            onClick={() => handleClickClose(false)}
          />
        </div>
        <div className="relative">
          <Image
            src={`${mapAsset.url}?fm=webp`}
            alt="map"
            width={mapAsset.width}
            height={mapAsset.height}
            className="w-full"
            hasPlaceholder
          />
        </div>
        <div className="gap-sm flex">
          <Typography.LLABEL2 className="flex-1">{address}</Typography.LLABEL2>
          <Button
            className="flex-1 no-underline"
            primary
            type={BUTTON_SUBTYPE_CLASS.PRIMARY_WHITE_OUTLINE}
            content={{ text: "DIRECTIONS", url: directionsLink }}
          />
        </div>
        <Typography.LLABEL2>{contactNumber}</Typography.LLABEL2>
        <Button
          primary={true}
          type={BUTTON_SUBTYPE_CLASS.PRIMARY_WHITE}
          content={{ text: "get in touch" }}
          onClick={handleClickGetInTouch}
        />
      </div>
    </div>
  </div>
);

export default OfficeDetails;
